import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import { WindowMU } from "app/types/WindowMU"
import { tratamentoErroPadrao } from "../tratamentoErroPadrao"
import globalMU from "globalMU"

declare var window:WindowMU

export async function atualizarRecalcularParcelas({
    identificadorOrcamento, recalcular
}:{
    identificadorOrcamento:string,
    recalcular:boolean
}):Promise<boolean> {
    var resposta;
    try { 
        await microuniversoApi.Orcamento.atualizarRecalcularParcelas(identificadorOrcamento, recalcular)
        window.orcamentoController.model.atualizar({
            ...(store.getState().orcamento),
            RecalcularParcelas: recalcular
        } as IOrcamento, true,true)
        resposta = true;
    }
    catch (e) {
        tratamentoErroPadrao(e);
        resposta = false;
    }
    finally{
        globalMU.unblockUI();
    }       
    return resposta;
}
